import angular from 'angular';

/* @ngInject */
export default function ($datepickerProvider) {
    angular.extend($datepickerProvider.defaults, {
        dateFormat: 'yyyy-MM-dd',
        startWeek: 1,
        iconLeft: 'fa fa-chevron-left',
        iconRight: 'fa fa-chevron-right',
    });
}



// WEBPACK FOOTER //
// ./src/app/config/datepicker.js